var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{staticClass:"w-100 secure-page",attrs:{"spinning":_vm.spinning}},[_c('user-phone',{attrs:{"data":_vm.info},on:{"success":_vm.onSuccess}}),_c('user-email',{attrs:{"data":_vm.info},on:{"success":_vm.onSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }